import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { PaymentMethodModel } from '@app/models';

@Injectable({
    providedIn: 'root',
})
export class PaymentMethodService
{
    private endPoint = '/paymentMethods';
    private http = inject(HttpClient);

    getPaymentMethods(): Promise<PaymentMethodModel[]>
    {
        return firstValueFrom(this.http.get<PaymentMethodModel[]>(this.endPoint));
    }
}
